<template>
  <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <h1>{{ $t('nav.monitoring_certificatedeployments') }}</h1>

         <ddoClientList name="StartingList2" key="StartingList2" :loading="loading" :level="levels[0]"
            :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
            :customSlotNames="levels[0].customSlotNames"
            ref="myCEDList2"
            >

            <template slot="header" slot-scope="props">
               <!-- Must return something to override default slot content -->
               <span></span>
            </template>

            <template slot="ced_last_severity" slot-scope="props">
               <v-chip
                  :color="compute_chip_color(props.row.ced_last_severity)"
                  text-color="white"
               >
                  <v-icon v-if="props.row.ced_last_severity==0">mdi-thumb-up</v-icon>
                  <v-icon v-if="props.row.ced_last_severity==1">mdi-alert-circle</v-icon>
                  <v-icon v-if="props.row.ced_last_severity==2">mdi-thumb-down</v-icon>
                  <v-icon v-if="props.row.ced_last_severity>2"></v-icon>
               </v-chip>
            </template>

            <template slot="ced_code" slot-scope="props">
               <small>{{props.row.ced_check_uri}}<br/>({{props.row.ced_code}})</small>
            </template>

            <template slot="ced_active" slot-scope="props">
               <b-checkbox disabled v-model="props.row.cer_active"><small>{{ $t('texts.ced_cer_active') }}</small></b-checkbox>
               <b-checkbox disabled v-model="props.row.cer_visible"><small>{{ $t('texts.ced_cer_visible') }}</small></b-checkbox>
               <b-checkbox disabled v-model="props.row.ced_active"><small>{{ $t('texts.ced_ced_active') }}</small></b-checkbox>
            </template>

            <template slot="ced_history" slot-scope="props">
               <v-chip v-for="day in props.row.ced_history" :key="day.date"
                  :color="compute_chip_color(day.esv_severity)"
               >
                  {{ $api._d(day.date,'daymonth') }}
               </v-chip>
            </template>

         </ddoClientList>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import ddoClientList from '@/components/ddoClientList.vue';

let initial_row = {}

export default {
   name: 'certificatedeployment',
   components: {
      ddoAlert,
      ddoWaiting,
      ddoClientList,
   },
   data: () => {
      return {
         _this: null,
         loading: false,

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [

         {
            /* 
             * LEVEL 0 :
             */
            api_code: 'certificatedeployment',
            api_prefix: 'ced',
            row: {},
            level: 0,
            errors: [],
            columns: [ 'ced_last_severity', 'cer_cn', 'ced_code', 'ced_active', 'ced_history' ],
            customSlotNames: ['ced_last_severity', 'ced_code', 'ced_active', 'ced_history'],
            options: {
               showChildRowToggler: false,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  ced_pk: '#',
                  ced_last_severity: '',
                  cer_cn: i18n.t('headers.cer_cn'),
                  ced_code: i18n.t('headers.ced_check_uri_and_code'),
                  cer_active: i18n.t('texts.cer_active'),
                  ced_active: i18n.t('headers.flags'),
                  ced_history: i18n.t('texts.ced_history'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               uniqueKey: 'ced_pk'
            },
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
         }

         ],

         model: {},
         dialogShow: false,
         dialogId: null,
         dialogcode: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows;
   },

   mounted() {
   },

   methods: {

      compute_chip_color(severity) {
         switch ( severity) {
            case 0 : return "green"; break;
            case 1 : return "orange"; break;
            case 2 : return "red"; break;
            default: return "grey"; break;
         }
      },

      build_row_history(field) {
         field = field.replace(/[\{\}]/,'');
         var history= [];
         var fields = field.split(',');
         for ( var j=0;j<fields.length;j++ ) {
            var details = fields[j].split('|');
            history.push( { date: details[0], reason: details[1], esv_code: details[3], esv_severity_text: details[4], esv_severity: parseInt(details[6]) } );
         }
         return history;
      },

      async refresh_rows(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/certificate_history');
         this.loading = false;
         if ( api_response.error==0 && api_response.rows ) {
            for ( var i=0;i<api_response.rows.length;i++ ) {
               api_response.rows[i].cer_visible = !api_response.rows[i].cer_masked;
               if ( api_response.rows[i].array ) {
                  api_response.rows[i].ced_history = this.build_row_history(api_response.rows[i].array);
                  //console.log('refresh_rows, i='+i+', found array, history='+JSON.stringify(api_response.rows[i].ced_history))
               }
            }
         }
         return { errorinfos, api_response }
      },

   }
}
</script>